import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { UserGameProfileFeaturesShellComponent } from './shell.component';
import { UserGameProfileLayoutComponent } from '@fantaz/user-game-profile/ui/user-game-profile-layout';
import { UserGameProfileDataAccessModule } from '@fantaz/user-game-profile/data-access';
import { AuthGuard } from '@fantaz/shared/auth';

/**
 * Configures the routes for the UserGameProfileFeaturesShellModule
 */
export const userGameProfileRouting: Routes = [
  {
    path: 'user-game-profile',
    component: UserGameProfileFeaturesShellComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        loadComponent: () =>
          import('@fantaz/user-game-profile/features/create-profile').then(
            (m) => m.CreateGameProfileFeatureComponent,
          ),
        data: {
          breadcrumb: 'Player Profile',
        },
      },
    ],
  },
];

@NgModule({
  imports: [
    CommonModule,
    UserGameProfileLayoutComponent,
    UserGameProfileDataAccessModule,
    RouterModule.forChild(userGameProfileRouting),
  ],
  declarations: [UserGameProfileFeaturesShellComponent],
  providers: [],
  exports: [RouterModule],
})
export class UserGameProfileFeaturesShellModule {}
